import { render, staticRenderFns } from "./StartCreation.vue?vue&type=template&id=951c127e"
import script from "./StartCreation.vue?vue&type=script&lang=js"
export * from "./StartCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports